import { styled } from "@acko-tech/building-blocks.ui.common";

export const PlansBox = styled.div`
border: 2px solid var(--Border-Disabled-grey50, #F5F5F5);
margin-bottom: ${(props) => props?.style?.margin_bottom ? props?.style?.margin_bottom : '0px'};
border-radius: 24px;
z-index: 1;
width: 100%;
display: ${(props) => props?.is_visible ? 'block' : 'none'};
`;

export const Container = styled.div``;

export const FlexContainer = styled.div`
display: flex;
align-items: center;
gap: 8px;
justify-content: center;
margin-bottom: 16px;
`;

export const GarageNameText = styled.div`
font-family: 'Euclid Circular B', 'Inter', sans-serif;
font-size: 14px;
font-style: normal;
font-weight: 600;
line-height: 20px; /* 142.857% */
background: linear-gradient(269deg, #F16262 -10.35%, #743DDC 106.34%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;

`;
